/* ––
 * ––– Imports
 * –––––––––––––––––––––––––––––––– */
import PropTypes               from 'prop-types';
import React, { useEffect }    from 'react';
import { Map, Iterable, List } from 'immutable';

import Grid             from '@mui/material/Grid';
import Radio            from '@mui/material/Radio';
import RadioGroup       from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl      from '@mui/material/FormControl';
import Linkify          from 'components/Generic/Linkify';

/* ––
 * ––– Component
 * –––––––––––––––––––––––––––––––– */
function MultipleChoice({
  value = null,
  name = null,
  onChange = null,
  options = new List(),
  disabled = false,
  forced = false,
}) {
  /* –– Handlers
   * –––––––––––––––––––––––––––––––– */
  function onSelect(newValue) {
    onChange(name, new Map({ text: newValue }));
  }

  useEffect(() => {
    if (forced) {
      onChange(name, new Map({ text: (value && value.get('value')) || t('eos.landing_page.label.no_answer'), forced: true }));
    }
  }, [forced]);

  /* –– Render
   * –––––––––––––––––––––––––––––––– */
  return (
    <Grid item xs={12} sx={{ mt: 1, ml: 2 }}>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="site"
          name="radio-buttons-group"
          onChange={(e) => onSelect(e.target.value)}
          value={value && value.get('value')}
          sx={{
            '.MuiButtonBase-root': {
              py: '5px',
            },
          }}
        >
          {
            options.map((option) => <FormControlLabel key={option} value={option} control={<Radio color="primary" />} label={<Linkify>{option}</Linkify>} disabled={disabled} />)
          }
        </RadioGroup>
      </FormControl>
    </Grid>
  );
}

/* ––
 * ––– Props declaration
 * –––––––––––––––––––––––––––––––– */
MultipleChoice.propTypes = {
  value:    PropTypes.objectOf(Iterable),
  name:     PropTypes.string,
  onChange: PropTypes.func,
  options:  PropTypes.objectOf(Iterable),
  disabled: PropTypes.bool,
  forced:   PropTypes.bool,
};

/* ––
 * ––– Exports
 * –––––––––––––––––––––––––––––––– */
export default MultipleChoice;
